import { useSnapshot } from "valtio";
import { myactionsstore } from "./store-myactions";
import { configStore } from "../state/CommonState";
import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import MonApi from "../state/mongo-api";
import {SHIPMENT_TYPE, SHIPMENT_SCOPE} from '../util/constants'
import Api from "../state/Api";
import { BsFillEyeFill } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import Utils from "../util/Utils"

    
export function ExceptionModal(props){
    useSnapshot(myactionsstore);
    useSnapshot(configStore);
    let ret = configStore.modalvisibledata;
    let status = [{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed" }]
    let mileStoneArr;
    let destination = ret?.destination2 ? 'Multiple' : 'Destination'
    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p && ret.por === ret.pol){
        mileStoneArr = [
            { value: "pol_location", label: "POL" },
            // { value: "fpod_location", label: "FPOD" },
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p && ret.por !== ret.pol){
        mileStoneArr = [
            { value: "por_location", label: "POR" },
            { value: "pol_location", label: "POL" },
            { value: "pod_location", label: "POD" },
            // { value: "fpod_location", label: "FPOD" },
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d && ret.por === ret.pol){
        mileStoneArr = [
            { value: "pol_location", label: "POL" },
            { value: "fpod_location", label: "FPOD" },
            // { value: destination, label: destination }
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d  && ret.por !== ret.pol){
        mileStoneArr = [
            { value: "por_location", label: "POR" },
            { value: "pol_location", label: "POL" },
            { value: "pod_location", label: "POD" },
            { value: "fpod_location", label: "FPOD" },
            // { value: destination, label: destination }
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d && ret.por === ret.pol){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "pol_location", label: "POL" },
            { value: "fpod_location", label: "FPOD" },
            // { value: destination, label: destination }
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d && ret.por !== ret.pol){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "por_location", label: "POR" },
            { value: "pol_location", label: "POL" },
            { value: "pod_location", label: "POD" },
            { value: "fpod_location", label: "FPOD" },
            // { value: destination, label: destination }
            ];
    }

    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p && ret.por === ret.pol){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "pol_location", label: "POL" },
            // { value: "fpod_location", label: "FPOD" },
            ];
    }
    if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p && ret.por !== ret.pol){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "por_location", label: "POR" },
            { value: "pol_location", label: "POL" },
            { value: "pod_location", label: "POD" },
            // { value: "fpod_location", label: "FPOD" },
            ];
    }

    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p){
        mileStoneArr = [
            { value: "departure_airport_location", label: "AOD" },
            ];
    }

    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d){
        mileStoneArr = [
            { value: "departure_airport_location", label: "AOD" },
            { value: "arrival_airport_location", label: "AOA" },
            ];
    }
    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "departure_airport_location", label: "AOD" },
            ];
    }
    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "departure_airport_location", label: "AOD" },
            { value: "arrival_airport_location", label: "AOA" },
            ];
    }

    let transhipment = ['ts1_port_location', 'ts2_port_location', 'ts3_port_location', 'ts4_port_location']
    let transhipmentAir = ['ts1_airport_location', 'ts2_airport_location', 'ts3_airport_location', 'ts4_airport_location']
    let reworkingType = ['reworking_pol_port_location', 'reworking_pod_port_location']
    if(ret.shipmentType === 'Air'){
        transhipmentAir.forEach((ele, index) => {
            if(ret[ele] !== undefined && ret[ele] !== "") mileStoneArr.push({ value: ele, label: `Transhipment ${index+1}` }) 
        })
    }else{
        transhipment.forEach((ele, index) => {
            if(ret[ele] !== undefined && ret[ele] !== "") mileStoneArr.push({ value: ele, label: `Transhipment ${index+1}` }) 
        })
    }
    reworkingType.forEach((ele, index) => {
        if(ret[ele] !== undefined && ret[ele] !== "") mileStoneArr.push({ value: ele, label: `Reworking ${index === 0 ? 'POL' : 'POD'}` }) 
    })


    const exception = {
        optionSelected: '',
        milestoneSelected: '',
        remarks: "",
        isActive: true,
        notifyCustomer: false,
        email: false,
        pkey: '',
        fileLink: ''
    }

    const [errors, setErrors] = useState([]);
    const [formData, setFormData] = useState(ret?.exceptionData && ret?.exceptionData?.length > 0  ? ret.exceptionData : [exception]);
    const [optionSelected, setSelected] = useState(ret?.exceptionData?.exceptionlist ? ret.exceptionData.exceptionlist : []);
    const [exceptionList, setException] = useState([]);
    const defaultException = [
        "Delayed Arrival at CFS",
        "Export Clearance Issues",
        "Container Roll-over by Carrier due to Load Count Restrictions",
        "Rolled-over due to Less Inducement",
        "Import Clearance Issues",
        "Pick-up by Transporter Delayed",
        "Pending for Appointment with Amazon",
        "Pending for Appointment with Consignee",
        "Incorrect Delivery Information Provided and On-hold for Approvals"
    ];

    const fetchFields = async () => {
        try {
            const url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/visibility/exceptions`;
            const response = await MonApi.apost(url, {});

            if (response && response.allFields) {
                response.allFields.map((ele) => defaultException.push(ele));
                let exceptionData = defaultException.map(item => ({value: item, label: item}))
                exceptionData = [...exceptionData, {value: "", label: "", isDisabled: true}]
                setException(exceptionData);
            }else{
                setException(defaultException.map(item => ({
                    value: item,
                    label: item
                })));
            }
        } catch (error) {
            console.error("Error fetching fields:", error);
        }
    };
    
    useEffect(() =>{
        fetchFields()
    }, [])

    const updateRow = (index, key, value) => {
        setFormData((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, [key]: key === 'isActive' ? 
            value.label === 'Closed' ? false : true : value } : item
          )
        );
    };

    function hasDuplicate(data) {
        let seen = new Set();
        return data.some(item => {
            let key = `${item.optionSelected.value}|${item.milestoneSelected.value}`;
            if (seen.has(key)) {
                return true;
            }
            seen.add(key);
            return false;
        });
    }
      
    function checkValidation() {
        let newErrors = formData.map((ele, rowIndex) => ({
            optionSelected: !ele.optionSelected,
            milestoneSelected: !ele.milestoneSelected,
            remarks: ele.remarks.trim() === "",
        }));
        setErrors(newErrors);
        if(hasDuplicate(formData)){
            configStore.setModalMessage("Same ExceptionType and Milestone Not Allowed") 
        }else if(newErrors.every((err) => !err.optionSelected && !err.milestoneSelected && !err.remarks )){
            return true
        }else{
            configStore.setModalMessage("Please Check the Fields") 
        }
    }

    function updateFile(files, label, key, index) {
        const formfileData = new FormData();
        formfileData.append("myFile", files);
        formfileData.append("label", label);
        formfileData.append("key", key);
        fetch(`${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`, {
          method: "POST",
          headers: Api.H1(),
          credentials: Utils.shouldSendCredentials(process.env.REACT_APP_FILE_SERVER) ? 'include' : 'omit',
          body: formfileData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
                configStore.setModalMessage(data.error);
                setFormData((prev) => prev.map((item, i) => i === index ? 
                {...item, pkey: '', fileLink: ''} : item ));
            }else {
                setFormData((prev) => prev.map((item, i) => i === index ? 
                {...item, pkey: data.key.pkey, fileLink: data.key.filename} : item ));
            }
          })
          .catch((error) => {
            console.error("error on updateFile:", error);
          });
    }

    const onsubmit = () => {
        if(checkValidation()){
            let li = Object.keys(ret)
            let lvs = {}
            for (let i = 0; i < li.length; i++) {
                lvs[li[i]] = ret[li[i]]
            }
            let exceptionlistArr = [];
            optionSelected.map((ele) => exceptionlistArr.push(ele));
            lvs.exceptionData = formData;
            configStore.modalvisibledata = lvs;
            myactionsstore.exceptionModalVisible = false;
        }
        
    };


    let modalClass = 'modal'
    if (myactionsstore.exceptionModalVisible) modalClass += ' is-active'
    return(
        <>  
            { myactionsstore.exceptionModalVisible && formData && formData.length > 0  ?
                <div class={modalClass} onClick={() => { myactionsstore.exceptionModalVisible = false }}>
                    <div className="modal-background" ></div>
                    <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{overflow: 'visible', borderRadius: '10px',width:"75rem"}} >
                        <section className="p-8 modal-card-body" style={{overflow: formData.length >= 4 ? 'scroll' : 'visible', width: "70em",borderRadius:"7px",display: 'flex', 
                            flexDirection: 'column', margin: 'auto', height: formData.length >= 4 ? '425px' : ''}} >
                            <h1 class="mb-3 text-xl font-semibold">Exception and Alerts</h1>
                            {formData.map((ele, index) =>(
                                <div class='flex mt-2 mb-3' key={index+1}>
                                    <Select 
                                        options={exceptionList}
                                        isDisabled={ele.email} 
                                        onChange={(selected) => updateRow(index, "optionSelected", selected)}
                                        value={ele.optionSelected}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                marginRight: '10px',
                                                width: '210px',
                                                borderColor: errors[index]?.optionSelected ? "red" : provided.borderColor
                                            }),
                                        }}
                                        placeholder={'Select Excetion Type'}
                                        maxMenuHeight={200}
                                    />
                                    <Select 
                                        options={mileStoneArr}
                                        isDisabled={ele.email} 
                                        onChange={(selected) => updateRow(index, "milestoneSelected", selected)}
                                        value={ele.milestoneSelected}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                        styles={{
                                        control: (provided) => ({
                                                ...provided,
                                                marginRight: '10px',
                                                width: '150px',
                                                borderColor: errors[index]?.milestoneSelected ? "red" : provided.borderColor
                                            }),
                                        }}
                                        placeholder={'MileStone'}
                                        maxMenuHeight={200}
                                    />
                                    <textarea placeholder="Remarks" rows='3'
                                        disabled={!ele.isActive} 
                                        style={{ 
                                            width: "230px",
                                            height: "38px",
                                            padding: "6px 10px",
                                            background: !ele.isActive ? '#f2f2f2' : '',
                                            borderColor: errors[index]?.remarks ? "red" : "#cccccc",
                                            borderRadius: "5px",
                                            fontSize: "16px",
                                            outline: "none",
                                            resize: "vertical",
                                            transition: "border 0.3s ease",
                                            color: !ele.isActive ? '#999999' : '',
                                            marginRight: '10px'
                                        }} 
                                        value={ele.remarks}
                                        maxLength={200}
                                        onChange={(e) => updateRow(index, "remarks", e.target.value)} />
                                    <Select 
                                        isDisabled={!ele.isActive && !ret.exceptionData[index]?.isActive}
                                        options={[{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed", isDisabled: !ele.email}]}
                                        defaultValue={status.filter((sts) => ele.isActive ? sts.label === 'Open' : sts.label === 'Closed')}
                                        onChange={(selected) => updateRow(index, "isActive", selected)}
                                        value={status.filter((sts) => ele.isActive ? sts.label === 'Open' : sts.label === 'Closed')}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                        styles={{
                                        control: (provided) => ({
                                                ...provided,
                                                marginRight: '10px',
                                                width: '110px',
                                            }),
                                        }}
                                        maxMenuHeight={150}
                                    />
                                    <div class="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            id="notifyCustomer"
                                            checked={ele.notifyCustomer}
                                            onChange={(e) => updateRow(index, "notifyCustomer", e.target.checked)}
                                            class="text-green-600"
                                        />
                                        <label htmlFor={`notifyCustomer-${index}`} className="font-medium ml-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Notify Customer</label>
                                    </div>
                                    {
                                        !ele.email && ele.fileLink === "" ?
                                        <div class= 'flex items-center mx-4'>
                                            <label htmlFor={`fileInput-${index+1}`} className="cursor-pointer">
                                                <i
                                                    class="fa-solid fa-file-arrow-up is-clickable"
                                                    style={{ 
                                                        fontSize:'28px'
                                                    }}
                                                />
                                            </label>
                                            <input
                                                style={{ display: 'none' }}
                                                id={`fileInput-${index+1}`}
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                                                onChange={(e) => {
                                                    console.log("onChange", !e.target.files[0])
                                                    if(!e.target.files[0]) return
                                                    const maxSize = 5 * 1024 * 1024;
                                                    const allowedTypes = [
                                                    'image/jpeg',
                                                    'image/png',
                                                    'application/pdf',
                                                    ];
                                                
                                                    if (!allowedTypes.includes(e.target.files[0].type)) {
                                                        configStore.setModalMessage('Invalid file type. Only images or PDFs are allowed.')
                                                        e.target.value = "";
                                                        return
                                                    }
                                                    
                                                    if (e.target.files[0].size > maxSize) {
                                                        configStore.setModalMessage("File size exceeds 5MB limit.")
                                                        e.target.value = "";
                                                        return
                                                    }

                                                    if(!ele.optionSelected.value){
                                                        configStore.setModalMessage("Please select Exception type")
                                                        e.target.value = "";
                                                        return
                                                    }
                                                    updateFile(e.target.files[0], 'Exception',  ele.optionSelected.value, index)
                                                }}
                                            />
                                        </div> : null
                                    }
                                    {
                                        ele.fileLink && ele?.fileLink !== "" ? 
                                        <div className="flex align-center justiify-center">
                                            <span class='icon mt-1 ml-3 is-size-4 '>
                                                <span className="ml-2 mr-1">
                                                    <a
                                                        href={
                                                        process.env.REACT_APP_FILE_SERVER +
                                                        "/api/v1/filestore/getfile/" +
                                                        ele?.pkey +
                                                        "/" +
                                                        ele?.fileLink
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        alt="">
                                                        <BsFillEyeFill />
                                                    </a>
                                                </span>
                                                
                                            </span>
                                            {
                                                !ele.email ? 
                                                    <span class='icon mt-1 ml-3 is-size-4'>
                                                        <span style={{ cursor: "pointer"}}>
                                                            <MdDelete
                                                                onClick={() => setFormData((prev) => prev.map((item, i) => i === index ? 
                                                                    {...item, pkey: '', fileLink: ''} : item ))
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                : null
                                            }
                                        </div>
                                        : null
                                    }
                                    
                                    <div>
                                        {
                                            formData.length - 1 === index ? 
                                            <button className="ml-3 button is-success is-inverted is-hovered is-active"
                                                onClick={() => {
                                                    setFormData((prev) => [...prev, { ...exception }])
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-plus"></i>
                                                </span>
                                            </button> : <></>
                                        }
                                        {
                                            formData.length > 1 ? 
                                            <button className="ml-3 button is-danger is-inverted is-hovered is-active"
                                                onClick={() => {
                                                    setFormData((prev) => prev.filter((_, i) => i !== index));
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-trash"></i>
                                                </span>
                                            </button> : <></>
                                        }
                                    </div>
                                </div>
                            ))}
                            <div class="my-4 is-flex is-justify-content-end">
                                <button class="mr-5 button is-warning" onClick={() => myactionsstore.exceptionModalVisible = false} >cancel</button>
                                <button class="button is-danger" onClick={onsubmit}>Submit</button>
                            </div>
                        </section>
                    </div>
                </div>
            : <></> }
        </>
    )
}